import { createStyles, Theme } from '@material-ui/core/styles';

const styles = (theme: Theme) =>
  createStyles({
    '@global .DraftEditor-root': {
      width: '100%',
      fontFamily: theme.typography.fontFamily,
      lineHeight: 1.5,
      fontSize: theme.typography.pxToRem(16),
      ...theme.mixins.breakWord,
    },
    '@global .DraftEditor-root a': {
      textDecoration: 'none',
      color: theme.palette.primary.main,
    },
    '@global .public-DraftEditorPlaceholder-root': {
      top: '50%',
      transform: 'translateY(-50%)',
      color: theme.palette.text.primary,
      opacity: 0.42, // matches text input style
      fontWeight: theme.typography.fontWeightRegular,
      zIndex: 2,
      pointerEvents: 'none',
    },
    toolbar: {
      display: 'inline-block',
      marginTop: theme.spacing(1),
    },
    buttonWrapper: {
      display: 'inline-block',
    },
    button: {
      border: `1px solid ${theme.custom.palette.grey3}`,
      paddingTop: 5,
      '& svg': {
        fill: theme.palette.text.secondary,
      },
      '&:hover, &:focus': {
        outline: 0,
        '& svg': {
          fill: theme.palette.text.primary,
        },
      },
    },
    active: {
      background: theme.custom.palette.grey3,
      '& svg': {
        fill: theme.palette.text.primary,
      },
    },
    mention: {
      color: theme.custom.palette.blue,
    },
    mentionSuggestions: {
      display: 'flex',
      flexDirection: 'column',
      position: 'absolute',
      minWidth: 200,
      maxWidth: 400,
      transform: 'scale(0)',
      marginTop: theme.spacing(1),
      background: theme.palette.common.white,
      border: `1px solid ${theme.custom.palette.grey3}`,
      boxShadow: theme.custom.shadows.depth2,
      zIndex: theme.zIndex.modal,
      cursor: 'pointer',
    },
    mentionSuggestionsEntry: {
      padding: theme.spacing(1),
      transition: 'background-color 100ms cubic-bezier(.27,1.27,.48,.56)',
    },
    mentionSuggestionsEntryFocused: {
      background: theme.custom.palette.green,
      color: theme.palette.common.white,
    },
    mentionSuggestionsEntryText: {
      marginLeft: theme.spacing(1),
    },
  });

export default styles;
